export const baseURL = '/api/v1/twitter_manager' as const;

export default {
  flows: `${baseURL}/get_flows/` as const,
  creativeSettings: `${baseURL}/get_creative_settings/` as const,
  updateCreativeSettings: (settingsId: number) => `${baseURL}/update_creative_settings/${settingsId}/` as const,
};
